<nav
  class="beta-menu"
  aria-label="Primary"
  [class.is-open]="isMenuOpen"
  [class.is-pinned]="isPinnedOpen"
  
  
>
  <div #rail class="beta-menu-rail" role="menubar" aria-orientation="vertical" >
    <ul class="beta-menu-rail-list" role="list">
      <li>
        <a
          class="beta-menu-branding"
          [routerLink]="['/ai/clarichat']"
          aria-label="ClariChat home"
          role="button"
          [attr.title]="isPinnedOpen ? 'Close sidebar' : 'Open sidebar'"
          [attr.aria-pressed]="isPinnedOpen"
          [attr.aria-label]="isPinnedOpen ? 'Close sidebar' : 'Open sidebar'"
          (click)="togglePinnedOpen($event)"
        >
          <img src="assets/svg/sosexy.png" class="beta-menu-logo" alt="" aria-hidden="true" />
          <span class="beta-menu-open-indicator" aria-hidden="true">
            <i class="fa-solid fa-square-caret-right"></i>
            <span class="beta-menu-open-tooltip">Keep sidebar opened</span>
          </span>
        </a>
      </li>

      <ng-container *ngFor="let section of sections; trackBy: trackBySection">
        <li>
          <button
            class="beta-menu-icon"
            type="button"
            role="menuitem"
            [attr.aria-label]="section.title"
            [attr.aria-haspopup]="'true'"
            [attr.aria-current]="section.id === activeSectionId ? 'true' : null"
            
            (focus)="setActiveSection(section.id)"
            (click)="onIconClick(section.id)"
          >
            <img *ngIf="section.iconSrc" [src]="section.iconSrc" [alt]="section.iconAlt || section.title" />
            <i *ngIf="section.iconClass" [class]="section.iconClass" aria-hidden="true"></i>
          </button>
        </li>
      </ng-container>
    </ul>
  </div>

  <aside 
    #panel
    class="beta-menu-panel" 
    aria-live="polite"
    
    
  >
    <div class="beta-menu-panel-inner">
      <header class="beta-menu-header" [attr.data-active-section]="activeSectionId">
        <div class="beta-menu-frozen" *ngIf="isPinnedOpen">
          <i class="fa-solid fa-lock" aria-hidden="true"></i>
          <span>Menu Locked</span>
        </div>
        <div class="beta-menu-title">
          <i [ngClass]="getSectionIconClass()" ></i>
          {{ activeSection.title }}
        </div>
        <div class="beta-menu-subtitle">{{ activeSection.subtitle }}</div>
      </header>

      <div class="beta-menu-links-wrapper">
        <ul
          class="beta-menu-links"
          *ngFor="let section of sections; trackBy: trackBySection"
          role="list"
          [class.is-active]="section.id === activeSectionId"
          [attr.data-section-id]="section.id"
        >
          <li *ngFor="let link of section.links; trackBy: trackByLink">
            <ng-container *ngIf="shouldShowLink(link)">
              <a
                class="beta-menu-link"
                [routerLink]="link.action === 'newChat' ? null : [link.route]"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: link.exact ?? false }"
                (click)="handleLinkClick(link, $event)"
                [attr.href]="link.action === 'newChat' ? '#' : null"
                [attr.data-link-route]="link.route"
              >
                <span [innerHTML]="link.labelHtml || link.label"></span>
              </a>
            </ng-container>
          </li>
          
          <!-- Conversation History (only for chat section) -->
          <ng-container *ngIf="section.id === 'chat'">
            <li class="beta-conversation-history-header wet" *ngIf="isLoggedIn && recentConversations.length > 0">
              <div class="beta-conversation-history-divider"></div>
              <!-- <div class="beta-conversation-history-title " style="font-size: 1rem;">Conversations</div> -->
              <div class="aliconvo">Your Chats</div>
            </li>

            <li 
              class="beta-conversation-item" 
              *ngFor="let conv of recentConversations; trackBy: trackByConversationId"
              (click)="!editingTopicId && loadConversation(conv.id)"
              (mouseenter)="hoveredConversationId = conv.id"
              (mouseleave)="hoveredConversationId = null"
            >
              <a
                class="beta-menu-link beta-conversation-link"
                *ngIf="editingTopicId !== conv.id"
                [routerLink]="['/ai/clarichat']"
              >
                <div class="beta-conversation-content">
                  <div class="beta-conversation-line">
                    <!-- <i class="fa-solid fa-message" aria-hidden="true"></i> -->
                     <i class="fa fa-message fa-message-ali">&nbsp;{{ conv.messages?.length || 0 }}&nbsp;</i>
     <!-- <span class="beta-conversation-count-ali fa-convo-ali"></span> -->
                    <span class="beta-conversation-topic" [title]="conv.topic || 'Conversation'">
                      {{ truncateTopic(conv.topic || 'Classified Chat') }}
                    </span>
                    <button
                      class="beta-conversation-edit-btn"
                      *ngIf="!editingTopicId"
                      (click)="startEditingTopic(conv.id, conv.topic || ''); $event.stopPropagation()"
                      type="button"
                      aria-label="Edit topic"
                    >
                      <i class="fa-regular fa-pen-to-square"></i>
                    </button>
                  </div>
                </div>
              </a>
              
              <!-- Edit Mode -->
              <div class="beta-conversation-edit-mode" *ngIf="editingTopicId === conv.id">
                <input
                  type="text"
                  class="beta-conversation-topic-input"
                  [(ngModel)]="editingTopicValue"
                  (keydown.enter)="saveTopic(conv.id)"
                  (keydown.escape)="cancelEditingTopic()"
                  (blur)="saveTopic(conv.id)"
                  #topicInput
                  maxlength="60"
                  placeholder="Enter topic..."
                />
                <div class="beta-conversation-edit-actions">
                  <button 
                    class="beta-conversation-save-btn"
                    (click)="saveTopic(conv.id)"
                    type="button"
                    aria-label="Save"
                  >
                    <i class="fa-solid fa-check"></i>
                  </button>
                  <button 
                    class="beta-conversation-cancel-btn"
                    (click)="cancelEditingTopic()"
                    type="button"
                    aria-label="Cancel"
                  >
                    <i class="fa-solid fa-xmark"></i>
                  </button>
                </div>
              </div>
            </li>
    
            <li class="beta-conversation-loading" *ngIf="isLoggedIn && loadingConversations">
              <div>Loading conversations...</div>
            </li>
          </ng-container>
        </ul>
      </div>
    </div>
  </aside>
</nav>
